import "./sw-main.module.css";
import { html, LANGUAGE } from "../global.ts";
import Strings from "../../models/Strings.json";

const template = document.createElement("template");
template.innerHTML = html`
    <sw-home class="hidden py-[72px]"></sw-home>
    <sw-page class="hidden py-[72px] touch-zoom"></sw-page>
    <sw-map class="hidden w-full h-full"></sw-map>
`;

export default template;
